module.exports = __webpack_public_path__ + "img/press.2893d86.jpg";